import Default from "./_base"
import Blog from "./blog"
import Homepage from "./homepage"
import Explore from "./explore"
import Search from "./search"
import FeaturedExhibition from "./featuredExhibition"

export default {
  Default: Default,
  Homepage: Homepage,
  Blog: Blog,
  Explore: Explore,
  Search: Search,
  FeaturedExhibition: FeaturedExhibition,
}
